import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";

export function useRemoteCreateCateringMenu() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, FormData>({
    key: ["create-catering-menu"],
    url: `/booking-services/catering-services`,
    method: "post",
    snackbarTextOnSuccess: t("Successfully created a catering"),
    snackbarTextOnFail: t(`There was a server error`)
  });
}
